import { render, staticRenderFns } from "./SalidasView.vue?vue&type=template&id=a7dcfc90&"
import script from "./SalidasView.vue?vue&type=script&lang=js&"
export * from "./SalidasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports